import axios from '@/util/axios';
import common from '../common'

export default {
    list(params) {
        return common.get('/rocheManage/sys/permission/list',params);
    },

    add(params) {
        return common.post('/rocheManage/sys/permission/add',params);
    },

    edit(params) {
        return common.put('/rocheManage/sys/permission/edit',params);
    },

    delete(params) {
        return common.delete('/rocheManage/sys/permission/delete',params);
    },

    deleteBatch(params) {
        return common.delete('/rocheManage/sys/permission/deleteBatch',params);
    },
}



// WEBPACK FOOTER //
// ./src/api/sysmanagement/menulist.js